import { faBolt, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ModalWrapper from './ModalWrapper'
import { useModalState } from '@/features/modal-manager'

interface UpgradeModalProps {
  message?: string
}

export default function UpgradeModal({
  message = 'Upgrade to unlock premium features',
}: UpgradeModalProps) {
  // Get full internal state control - no need for open/setOpen props
  const modalState = useModalState()

  const handleUpgrade = () => {
    window.open('https://rundownstudio.app#pricing', '_blank')
    modalState.close()
  }

  return (
    <ModalWrapper
      title="Time to upgrade"
      open={modalState.open}
      setOpen={modalState.setOpen}
      buttons={[
        {
          icon: faBolt,
          text: 'Upgrade my account',
          onClick: handleUpgrade,
        },
      ]}
    >
      <div className="flex flex-col gap-6 pb-4">
        <p className="font-semibold">{message}</p>
        <div className="text-gray-400">
          <p>With paid plans, you can...</p>
          <p className="flex gap-2 items-center">
            <FontAwesomeIcon icon={faCheckCircle} />
            Add more rundowns and events to your account.
          </p>
          <p className="flex gap-2 items-center">
            <FontAwesomeIcon icon={faCheckCircle} />
            Create unlimited cues and columns per rundown.
          </p>
          <p className="flex gap-2 items-center">
            <FontAwesomeIcon icon={faCheckCircle} />
            Invite more team members for collaboration.
          </p>
          <p className="flex gap-2 items-center">
            <FontAwesomeIcon icon={faCheckCircle} />
            Export rundowns in PDF and CSV formats.
          </p>
          <p className="flex gap-2 items-center">
            <FontAwesomeIcon icon={faCheckCircle} />
            Control rundowns through our API.
          </p>
          <p className="flex gap-2 items-center">
            <FontAwesomeIcon icon={faCheckCircle} />
            Upload files and media up to 1GB in rundown cells.
          </p>
        </div>
      </div>
    </ModalWrapper>
  )
}

UpgradeModal.displayName = 'UpgradeModal'
